/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';
export var NavigationMenuContext = createContext({
  menu: undefined,
  search: ''
});
export var useNavigationMenuContext = function useNavigationMenuContext() {
  return useContext(NavigationMenuContext);
};
//# sourceMappingURL=context.js.map